import { Component, inject } from '@angular/core';
import { MatDialogRef }      from '@angular/material/dialog';

import { DialogComponent }        from '../dialog.component';
import { DialogTitleComponent }   from '../title/title.component';
import { DialogContentComponent } from '../content/content.component';
import { DialogActionsComponent } from '../actions/actions.component';
import { ButtonComponent }        from '../../buttons/button.component';

@Component({
  selector: 'pin-app-inactivity-dialog',
  templateUrl: './inactivity-dialog.component.html',
  imports: [DialogComponent, DialogTitleComponent, DialogContentComponent, DialogActionsComponent, ButtonComponent]
})
export class InactivityDialogComponent {
  private dialogRef = inject<MatDialogRef<InactivityDialogComponent>>(MatDialogRef);

  continue() {
    this.dialogRef.close('continue');
  }
}
